import styled from 'styled-components'
import theme from 'theme_'
import { BodyPrimary, SectionLabel } from 'components/Typography'
import { SubInfoBlock } from '../styles'

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ActiveConfigUpdatedLabelContainer = styled(InfoWrapper)`
  line-height: 2;
`

export const ActiveConfigName = styled.div`
  font-weight: 900;
  word-break: break-word;
`

export const ActiveConfigLabelTime = styled(BodyPrimary)``

export const ActiveConfigUpdatedButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const ActiveConfigurationButtonWrapper = styled.div`
  padding: 4px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.pelicanGrey};
  max-height: 40px;
`

export const ActiveConfigurationContainer = styled(SubInfoBlock)`
  justify-content: space-between;
`

export const ActiveConfigurationHeaderContainer = styled(SectionLabel)`
  min-height: unset;
  margin: unset;
`
